import { rememberPostLoginPath } from "./postLoginRedirect";

// A visitor who is not signed in is sent to /auth/login by Routes.js's catch-all, which would otherwise lose where
// they were going (a QR scan from the phone's camera, an emailed link, the page open when their session ended).
// This remembers it (see postLoginRedirect.js) so signing in can take them back.
export default function ScanRedirectCapture() {
    // Must run during render: a passive effect fires only after the sibling
    // <Redirect> has already changed the URL, so the path would be lost.
    // Idempotent, so re-renders are harmless.
    rememberPostLoginPath(window.location.pathname + window.location.search);
    return null;
}
